import api from '../config/api';

export default function getImagePath(url, width, height) {
  if (!url) return '';
  return `${api.host}${url}?width=${width}&height=${height}`;
}
